var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"listoutline",on:{"click":function($event){return _vm.PrepareSecurityRules()}}},[_c('v-list-item-title',{staticClass:"subtleoverline"},[_vm._v(" Publish Security Rules ")]),_c('v-list-item-action',[_c('v-icon',{attrs:{"color":"warning"}},[_vm._v("mdi-security-network")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }